let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let FormMixin = require("react-loose-forms");
let FormUtils = require("../../../../utils/FormUtils");
let Constants = require("../../../../utils/Constants");
let AuthedUserSession = require("../../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  mixins: [FormMixin],
  getInitialValues({query}) {
    return !query ? {
      hide_closed_events: _.get(this.props, "Displaylists.user.myevents_preferences.hide_closed_events_in_results", false),
    } : {
      searchterm: query.searchterm || null,
      deepsearch: !!query.deepsearch,
      includecanceled: _.isArray(query.exclude_event_types) && !_.includes(query.exclude_event_types, Constants.EVENT_STATUSES.canceled),
      cross_companies: !!query.cross_companies,
      datelessonly: !!query.datelessonly,
      marketplaceonly: !!query.marketplaceonly,
      speaker_select: _.isArray(query.sids) && query.sids.length > 0 ? _.first(query.sids) : -1,
      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"]),
      hide_closed_events: !!query.hide_closed_events,
    };
  },
  buildSchema() {
    let speakers = this.props.speakers;
    return {
      searchterm: {
        type: "text",
        placeholder: "Search",
        validate: FormUtils.v.optional//accepts searches w/o a query
      },
      speaker: {
        type: "select",
        placeholder: "-- select speaker --",
        options: speakers,
        validate: FormUtils.v.optional//accepts searches w/o a speaker
      },
      deepsearch: {
        label: "deep search",
        type: "checkbox"
      },
      includecanceled: {
        label: "include canceled",
        type: "checkbox"
      },
      datelessonly: {
        label: "only dateless events",
        type: "checkbox"
      },
      cross_companies: {
        label: 'other companies',
        type: 'checkbox'
      },
      hide_closed_events: {
        label: 'hide closed events',
        type: 'checkbox'
      }
    };
  },
  render() {
    let fields = this.Form_buildSchema();
    let errors = this.state.errors || {};

    return dd.form({onSubmit: this.Form_onSubmit},
      dd.div({className: 'row'},
        dd.div({className: 'col-sm-6'},
          dd.div({className: "form-group" + (errors["searchterm"] ? " has-error" : ""), style: {marginBottom: "10px"}},
            dd.div({className: "input-group"},
              this.Form_buildInput(fields.searchterm),
              dd.span({className: "input-group-btn"},
                dd.button({type: "submit", className: "btn btn-default"},
                  dd.i({className: "fa fa-search"}),
                  " Search"
                )
              )
            )
          )
        ),
        dd.div({className: 'col-sm-6'},
          dd.div({className: "form-group" + (errors["speaker"] ? " has-error" : ""), style: {marginBottom: "10px"}},
            dd.div({className: "input-group"},
              this.Form_buildInput(fields.speaker)
            )
          )
        )
      ),
      _.map(["deepsearch", "includecanceled", "datelessonly", "cross_companies", "hide_closed_events"], function (name) {
        return dd.div({key: name, style: {display: "inline-block", marginRight: "1em"}},
          this.Form_buildInput(fields[name])
        );
      }, this),
      dd.div({className: "clearfix"})
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/TreeSearch/Form.js